import {
  ESSNVerificationStatus,
  EntityType,
  employeeOnboardSchema,
  zSchema,
} from "@zeal/common";

export const runSSNVerificationRequestSchema = zSchema.object({
  firstName: zSchema.string().min(1),
  middleName: zSchema.string().optional(),
  lastName: zSchema.string().min(1),
  redoPersonApplicationFields: employeeOnboardSchema.optional(),
  redoKYCFields: zSchema
    .object({
      entity_type: zSchema.nativeEnum(EntityType),
      first_name: zSchema.string(),
      middle_name: zSchema.string().nullish(),
      last_name: zSchema.string(),
      dob: zSchema.string(),
      zeal_id: zSchema.string(),
    })
    .optional(),
  previousSSNVerificationStatus: zSchema
    .nativeEnum(ESSNVerificationStatus)
    .optional(),
  personaVerificationStatus: zSchema.enum(["passed", "failed", "canceled"]),
  personaFailureReason: zSchema.string(),
  personaIdentityMismatches: zSchema.string(),
  zealId: zSchema.string(),
  metadata: zSchema.record(zSchema.any()).optional(),
});

export type TRunSSNVerificationRequestSchema = zSchema.infer<
  typeof runSSNVerificationRequestSchema
>;

export const runSSNVerificationResponseSchema = zSchema.any();

export type TRunSSNVerificationResponseSchema = zSchema.infer<
  typeof runSSNVerificationResponseSchema
>;
